import DigitalOrderConfig from 'umg-ember-backend/components/record-detail/for/digital-order-config';

<template><DigitalOrderConfig @model={{@model}} /></template>
